import { defineType } from "sanity";
import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  name: "accordionTextItem",
  type: "object",
  title: "Accordion Item",
  fields: [
    {
      name: "title",
      type: "multilingualArrayString",
      title: "Title"
    },
    {
      name: "content",
      type: "multilingualArrayBlockContent",
      title: "Content"
    }
  ],
  preview: {
    select: {
      title: "title"
    },
    prepare({ title }) {
      return {
        title: multilingualStringPreview(title)
      };
    }
  }
});
